/* ============================================================
   BULIER — IL MIO ACCOUNT
   Portato dal mockup (mockup/account.html) il 04/10/2026.
   Dal 04/10/2026: manichino fermo (solo per far vedere dove si
   misura), misure scritte a mano, foto inviate a BULIER (SEMPLIFY)
   col consenso della cliente. Niente piu' misure ricavate dalle foto.
   ============================================================ */
/* ---------------- schede dell'account ---------------- */
(function(){
  const bottoni = [...document.querySelectorAll('.schede button')];
  bottoni.forEach(b => b.addEventListener('click', () => {
    bottoni.forEach(x => {
      const si = x === b;
      x.setAttribute('aria-selected', si);
      document.getElementById(x.dataset.scheda).hidden = !si;
    });
  }));
})();

/* ---------------- la foto: si centra, poi va in tre posti ----------------
   La foto scelta si apre in un tondo grande: si trascina e si ingrandisce.
   Con "Usa questa foto" si ritaglia un quadrato da 480px (canvas) e quello
   va nei tre tondi. Sul sito vero si salva il ritaglio, non l'originale:
   pesa poco e non serve ricordarsi spostamento e zoom. */
(function(){
  const input = document.getElementById('fotoInput');
  const grande = document.getElementById('fotoGrande');
  const fin = document.getElementById('centra'), tondo = document.getElementById('centraTondo');
  const img = document.getElementById('centraImg'), zoom = document.getElementById('centraZoom');
  let x = 0, y = 0, base = 1, haFoto = false, originale = null;
  /* la foto gia' scelta l'altra volta: per ora sta nel browser */
  try {
    const salvata = localStorage.getItem('bulier-foto');
    if(salvata){
      document.querySelectorAll('[data-io]').forEach(el => { el.style.backgroundImage = `url("${salvata}")`; el.classList.add('ha-foto'); });
      haFoto = true; originale = salvata;
    }
  } catch(e){}

  const lato = () => tondo.clientWidth;
  const scala = () => base * parseFloat(zoom.value);
  /* la foto non deve mai lasciare vuoto il tondo */
  function limita(){
    const L = lato(), w = img.naturalWidth*scala(), h = img.naturalHeight*scala();
    x = Math.min(0, Math.max(L - w, x));
    y = Math.min(0, Math.max(L - h, y));
    img.style.transform = `translate(${x}px,${y}px) scale(${scala()})`;
  }
  function apri(url){
    originale = url;
    fin.hidden = false;
    img.onload = () => {
      const L = lato();
      base = L / Math.min(img.naturalWidth, img.naturalHeight);   /* riempie il tondo */
      zoom.value = 1;
      x = (L - img.naturalWidth*base)/2; y = (L - img.naturalHeight*base)/2;
      limita();
    };
    img.src = url;
  }

  grande.addEventListener('click', () => haFoto ? apri(originale) : input.click());
  input.addEventListener('change', e => {
    const f = e.target.files[0]; if(!f) return;
    apri(URL.createObjectURL(f)); input.value = '';
  });

  /* trascinare: dito o mouse */
  let presa = null;
  tondo.addEventListener('pointerdown', e => { presa = {px:e.clientX, py:e.clientY, x, y}; tondo.setPointerCapture(e.pointerId); });
  tondo.addEventListener('pointermove', e => {
    if(!presa) return;
    x = presa.x + e.clientX - presa.px; y = presa.y + e.clientY - presa.py; limita();
  });
  tondo.addEventListener('pointerup', () => presa = null);
  tondo.addEventListener('pointercancel', () => presa = null);

  /* lo zoom avvicina verso il centro del tondo, non verso l'angolo */
  let prima = 1;
  zoom.addEventListener('input', () => {
    const L = lato()/2, r = parseFloat(zoom.value)/prima;
    x = L - (L - x)*r; y = L - (L - y)*r; prima = parseFloat(zoom.value); limita();
  });
  zoom.addEventListener('pointerdown', () => prima = parseFloat(zoom.value));
  zoom.addEventListener('focus', () => prima = parseFloat(zoom.value));

  document.getElementById('centraOk').addEventListener('click', () => {
    const c = document.createElement('canvas'); c.width = c.height = 480;
    const k = 480/lato();
    c.getContext('2d').drawImage(img, x*k, y*k, img.naturalWidth*scala()*k, img.naturalHeight*scala()*k);
    const ritaglio = c.toDataURL('image/jpeg', .9);
    document.querySelectorAll('[data-io]').forEach(el => {
      el.style.backgroundImage = `url("${ritaglio}")`; el.classList.add('ha-foto');
    });
    haFoto = true; originale = ritaglio; fin.hidden = true;
    try { localStorage.setItem('bulier-foto', ritaglio); } catch(e){}
    /* e subito anche nel tondo della barra in basso */
    const tondoBarra = document.querySelector('.voce-basso--io .avatar');
    if(tondoBarra){ tondoBarra.style.backgroundImage = `url("${ritaglio}")`; tondoBarra.classList.add('ha-foto'); }
  });
  document.getElementById('centraCambia').addEventListener('click', () => input.click());
  document.getElementById('centraAnnulla').addEventListener('click', () => fin.hidden = true);
  fin.addEventListener('click', e => { if(e.target === fin) fin.hidden = true; });
  addEventListener('keydown', e => { if(e.key === 'Escape') fin.hidden = true; });
})();


/* ============================================================
   MISURE
   Ogni misura sa: dove si prende (la nota), e come si disegna
   sull'omino (una fascia orizzontale o una linea verticale).
   ============================================================ */
const M = {
  altezza:   {n:'Altezza', v:168, min:140, max:200, u:'cm', g:'base',
              dove:'In piedi, scalza, schiena al muro. Dalla pianta dei piedi alla sommità della testa.'},
  peso:      {n:'Peso', sub:'Facoltativo · non serve alla forma', v:'', min:35, max:150, u:'kg', g:'base',
              dove:'Facoltativo. Non lo usiamo per disegnare la forma: ci aiuta solo a capire come veste un capo morbido.'},
  sistema:   {n:'Sistema di taglie', v:'IT', g:'nascosto'},
  solita:    {n:'Taglia che porti di solito', v:'42', g:'base', scelta:['38','40','42','44','46','48'],
              dove:'La taglia che compri più spesso nei negozi. Scegli prima il tipo (italiana, europea, inglese, americana o a lettere): se non lo sai, guarda l\'etichetta di un capo che ti sta bene.'},
  spalle:    {n:'Spalle', sub:'Da una spalla all\'altra, dietro', v:38, min:30, max:52, u:'cm', g:'corpo',
              dove:'Dietro la schiena, da un\'estremità all\'altra delle spalle, dove finisce l\'osso. Fattela prendere da qualcuno.'},
  seno:      {n:'Seno', v:88, min:70, max:130, u:'cm', g:'corpo',
              dove:'Metro orizzontale nel punto più pieno del seno, passando sotto le braccia. Con il reggiseno che porti di solito.'},
  sottoseno: {n:'Sotto il seno', v:74, min:60, max:120, u:'cm', g:'corpo',
              dove:'Subito sotto il seno, dove appoggia la fascia del reggiseno. Metro aderente ma non stretto.'},
  vita:      {n:'Vita', v:70, min:54, max:130, u:'cm', g:'corpo',
              dove:'Il punto più stretto del busto, di solito due dita sopra l\'ombelico. Non trattenere il respiro.'},
  fianchi:   {n:'Fianchi', v:96, min:76, max:150, u:'cm', g:'corpo',
              dove:'Il punto più largo del bacino, sul gluteo. Piedi uniti, metro sempre orizzontale.'},
  coscia:    {n:'Coscia', v:54, min:38, max:90, u:'cm', g:'corpo',
              dove:'Intorno alla coscia nel punto più largo, circa 5 cm sotto l\'inguine. Gamba rilassata.'},
  interno:   {n:'Interno gamba', v:77, min:60, max:95, u:'cm', g:'corpo',
              dove:'Dall\'inguine fino a terra, all\'interno della gamba, scalza. Serve per la lunghezza dei pantaloni.'},
  braccio:   {n:'Lunghezza braccio', v:58, min:45, max:72, u:'cm', g:'corpo',
              dove:'Braccio appena piegato: dall\'estremità della spalla, passando sul gomito, fino al polso.'},
};
const ordineCorpo = ['spalle','seno','sottoseno','vita','fianchi','coscia','interno','braccio'];

function num(k){ const x = parseFloat(M[k].v); return isNaN(x) ? null : x; }

/* ---------- le misure salvate ----------
   PER ORA restano nel browser di chi le scrive (localStorage): da questa
   pagina Shopify non lascia scrivere nella scheda della cliente. Il passo
   dopo e' un'app (SEMPLIFY) che le salva nei campi della cliente, cosi'
   le ritrova da ogni telefono e il negozio le puo' usare. */
const CHIAVE_MISURE = 'bulier-misure';
const ACCOUNT = window.BULIER_ACCOUNT || {};
try {
  /* prima quelle dell'account (valgono da ogni telefono), se no quelle del browser */
  const salvate = ACCOUNT.misure || JSON.parse(localStorage.getItem(CHIAVE_MISURE) || '{}');
  Object.entries(salvate).forEach(([k, v]) => { if(M[k] && v !== '' && v != null) M[k].v = v; });
} catch(e){}

/* LE MISURE SCRITTE DALLA CLIENTE (04/10/2026, Andrea): tondino verde sul
   manichino e numero verde nell'elenco. I valori di partenza (esempio o
   forma scelta) restano bianchi: cosi' si vede cosa manca. */
const CHIAVE_INSERITE = 'bulier-misure-inserite';
let inserite = new Set();
try {
  const l = JSON.parse(localStorage.getItem(CHIAVE_INSERITE) || 'null');
  if(l) inserite = new Set(l);
  else if(ACCOUNT.misure) inserite = new Set(Object.keys(ACCOUNT.misure).filter(k => M[k] && ACCOUNT.misure[k] !== '' && ACCOUNT.misure[k] != null));
} catch(e){}
function segnaInserita(k){
  inserite.add(k);
  try { localStorage.setItem(CHIAVE_INSERITE, JSON.stringify([...inserite])); } catch(e){}
  document.querySelectorAll(`.riga[data-k="${k}"]`).forEach(r => r.classList.add('fatta'));
}

/* salvare nell'account: testo semplice, come vuole il proxy dell'app */
async function mandaAllAccount(corpo){
  if(!ACCOUNT.cliente || !ACCOUNT.salva) return false;
  try {
    const r = await fetch(ACCOUNT.salva, { method: 'POST', headers: { 'Content-Type': 'text/plain' }, body: JSON.stringify(corpo), credentials: 'same-origin' });
    const j = await r.json().catch(() => ({}));
    return r.ok && j.ok === true;
  } catch(e){ return false; }
}

/* ---------- le righe dei campi ---------- */
/* LA TAGLIA DI SOLITO E IL SUO SISTEMA (05/10/2026, Andrea): la cliente
   sceglie prima il sistema (italiana, europea, inglese, americana, a
   lettere) e poi la taglia in quel sistema. Dentro si tiene sempre la
   taglia ITALIANA (M.solita.v), piu' il sistema scelto (M.sistema.v).
   Equivalenze donna di uso comune: IT 38 = EU 34 = UK 6 = US 2 = XS. */
const SISTEMI = {
  IT: {n:'Italiana (IT)',            t:['38','40','42','44','46','48']},
  EU: {n:'Europea (EU · FR · DE)',   t:['34','36','38','40','42','44']},
  UK: {n:'Inglese (UK)',             t:['6','8','10','12','14','16']},
  US: {n:'Americana (US)',           t:['2','4','6','8','10','12']},
  LT: {n:'A lettere',                t:['XS','S','M','L','XL','XXL']}
};
function rigaTaglia(box){
  const r = document.createElement('div');
  r.className = 'riga riga--taglia' + (inserite.has('solita') ? ' fatta' : ''); r.dataset.k = 'solita';
  const sis = SISTEMI[M.sistema.v] ? M.sistema.v : 'IT';
  r.innerHTML = `<span class="riga__n">·</span>
    <span class="riga__nome">${M.solita.n}<small>Scegli prima il tipo di taglia</small></span>
    <span class="riga__campo riga__campo--due">
      <select aria-label="Tipo di taglia" data-sistema>${Object.entries(SISTEMI).map(([k, x]) => `<option value="${k}"${k===sis?' selected':''}>${x.n}</option>`).join('')}</select>
      <select aria-label="Taglia" data-taglia></select>
    </span>`;
  const selS = r.querySelector('[data-sistema]'), selT = r.querySelector('[data-taglia]');
  const pos = () => Math.max(0, SISTEMI.IT.t.indexOf(String(M.solita.v)));
  function riempi(){
    const lista = SISTEMI[selS.value].t, i = pos();
    selT.innerHTML = lista.map((t, j) => `<option value="${j}"${j===i?' selected':''}>${t}</option>`).join('');
  }
  riempi();
  selS.addEventListener('change', () => { M.sistema.v = selS.value; riempi(); segnaInserita('solita'); });
  selT.addEventListener('change', () => { M.solita.v = SISTEMI.IT.t[+selT.value]; segnaInserita('solita'); disegna(); calcola(); });
  [selS, selT].forEach(el => el.addEventListener('focus', () => scegli('solita')));
  box.appendChild(r);
}

function righe(contenitore, chiavi, numerate){
  const box = document.getElementById(contenitore);
  chiavi.forEach((k, i) => {
    if(k === 'solita'){ rigaTaglia(box); return; }
    const m = M[k];
    const r = document.createElement('label');
    r.className = 'riga' + (inserite.has(k) ? ' fatta' : ''); r.dataset.k = k;
    const campo = m.scelta
      ? `<select>${m.scelta.map(s => `<option${s==m.v?' selected':''}>${s}</option>`).join('')}</select>`
      : `<input type="number" inputmode="decimal" min="${m.min}" max="${m.max}" value="${m.v}" placeholder="—"><span>${m.u}</span>`;
    r.innerHTML = `<span class="riga__n">${numerate ? i+1 : '·'}</span>
      <span class="riga__nome">${m.n}${m.sub?`<small>${m.sub}</small>`:''}</span>
      <span class="riga__campo">${campo}</span>`;
    const el = r.querySelector('input,select');
    el.addEventListener('focus', () => scegli(k));
    el.addEventListener('input', () => { M[k].v = el.value; disegna(); calcola(); });
    el.addEventListener('change', () => { if(el.value !== ''){ segnaInserita(k); disegna(); } });
    r.addEventListener('mouseenter', () => { if(matchMedia('(hover:hover)').matches) scegli(k, true); });
    box.appendChild(r);
  });
}
righe('righeBase', ['altezza','peso','solita'], false);
righe('righeCorpo', ordineCorpo, true);


function scegli(k){
  attiva = k;
  document.querySelectorAll('.riga').forEach(r => r.classList.toggle('su', r.dataset.k === k));
  document.getElementById('notaDove').innerHTML = `<b>${M[k].n} — dove prenderla</b>${M[k].dove}`;
  disegna();
}

/* ---------- l'omino ----------
   La sagoma e' costruita dalle misure: l'altezza decide la scala
   (cm -> pixel), le circonferenze decidono le larghezze. Cosi' una
   ragazza alta con gli stessi fianchi esce piu' slanciata. */
const NS = 'http://www.w3.org/2000/svg';
const svg = document.getElementById('disegno');
const W = 220, CX = 110, TOP = 14, H = 440;

/* curva morbida che passa per tutti i punti (Catmull-Rom) */
function curva(p){
  let d = `M${p[0][0].toFixed(1)},${p[0][1].toFixed(1)}`;
  for(let i=0;i<p.length;i++){
    const p0=p[(i-1+p.length)%p.length], p1=p[i], p2=p[(i+1)%p.length], p3=p[(i+2)%p.length];
    const t=.18;
    d += ` C${(p1[0]+(p2[0]-p0[0])*t).toFixed(1)},${(p1[1]+(p2[1]-p0[1])*t).toFixed(1)} ${(p2[0]-(p3[0]-p1[0])*t).toFixed(1)},${(p2[1]-(p3[1]-p1[1])*t).toFixed(1)} ${p2[0].toFixed(1)},${p2[1].toFixed(1)}`;
  }
  return d + 'Z';
}


/* MANICHINO (04/10/2026, Andrea): una FOTO generata su Higgsfield (Nano
   Banana Pro, Unlimited) di un manichino da vetrina bianco opaco, testa a
   uovo, una gamba aperta, base tonda. Sta in assets/bulier-manichino.jpg
   (660x1498, ritagliata). E' ferma: serve solo a far vedere DOVE si prende
   ogni misura. Le linee stanno sopra, in coordinate della foto / 3
   (viewBox 220 x 499). Se si cambia la foto, vanno rimisurate. */
function disegnaCorpo(){
  svg.setAttribute('viewBox', '0 0 348 500');
  const segni = [
    {k:'altezza', d:'M83.5,20.9 L83.5,485.5 M78.3,20.9 L88.7,20.9 M78.3,485.5 L88.7,485.5', px:83.5, py:243.6},
    {k:'spalle', d:'M128.1,99.9 L219.9,99.9', px:114.8, py:91.2},
    {k:'braccio', d:'M219.2,101.6 L225.5,194.9 L226.9,255.8', px:245.3, py:104.4},
    {k:'seno', d:'M132.2,134.0 A41.8,5 0 0 0 215.8,134.0 A41.8,5 0 0 0 132.2,134.0', px:245.3, py:134.0},
    {k:'sottoseno', d:'M139.2,153.8 A34.8,4.5 0 0 0 208.8,153.8 A34.8,4.5 0 0 0 139.2,153.8', px:245.3, py:153.8},
    {k:'vita', d:'M144.8,181.7 A29.2,4 0 0 0 203.2,181.7 A29.2,4 0 0 0 144.8,181.7', px:245.3, py:181.7},
    {k:'fianchi', d:'M136.4,216.5 A38.3,6 0 0 0 213.0,216.5 A38.3,6 0 0 0 136.4,216.5', px:245.3, py:216.5},
    {k:'coscia', d:'M175.0,265.2 A18.8,3.5 0 0 0 212.6,265.2 A18.8,3.5 0 0 0 175.0,265.2', px:245.3, py:265.2},
    {k:'interno', d:'M169.1,247.8 L158.7,466.3', px:182.7, py:351.5}
  ];
  /* la foto si sfuma sui quattro lati e si fonde col fondo: niente riquadro */
  let html = `<defs>
      <linearGradient id="mn-sf-o" x1="0" x2="1"><stop offset="0" stop-color="#000"/><stop offset=".16" stop-color="#fff"/><stop offset=".84" stop-color="#fff"/><stop offset="1" stop-color="#000"/></linearGradient>
      <linearGradient id="mn-sf-v" x1="0" x2="0" y1="0" y2="1"><stop offset="0" stop-color="#000"/><stop offset=".08" stop-color="#fff"/><stop offset=".9" stop-color="#fff"/><stop offset="1" stop-color="#000"/></linearGradient>
      <mask id="mn-mo" maskContentUnits="userSpaceOnUse"><rect width="348" height="500" fill="url(#mn-sf-o)"/></mask>
      <mask id="mn-mv" maskContentUnits="userSpaceOnUse"><rect width="348" height="500" fill="url(#mn-sf-v)"/></mask>
    </defs>
    <g mask="url(#mn-mo)"><g mask="url(#mn-mv)">
      <image href="${ACCOUNT.manichino || ''}" x="0" y="0" width="348" height="500" preserveAspectRatio="xMidYMid slice"/>
    </g></g>`;
  segni.forEach(sg => {
    const su = sg.k === attiva;
    const n = ordineCorpo.indexOf(sg.k);
    html += `<path class="segno${su?' segno--su':''}" data-k="${sg.k}" d="${sg.d}"/>`;
    if(n >= 0){
      html += `<circle class="punto${su?' punto--su':''}${inserite.has(sg.k)?' punto--ok':''}" data-k="${sg.k}" cx="${sg.px}" cy="${sg.py}" r="8.5"/><text class="punto-n" x="${sg.px}" y="${sg.py}">${n+1}</text>`;
    } else if(su){
      html += `<circle class="punto punto--su" cx="${sg.px}" cy="${sg.py}" r="3"/>`;
    }
  });
  svg.innerHTML = html;
}

function disegna(){ disegnaCorpo(); }

/* tocca il segno sull'omino = vai al campo */
/* LA FINESTRA DELLA MISURA (04/10/2026, Andrea): tocchi un numero sul
   manichino -> come si prende + il campo per scriverla. Sul telefono sale
   dal basso, sul computer sta al centro. */
const pop = document.createElement('div');
pop.className = 'misura-pop'; pop.hidden = true;
pop.innerHTML = `<div class="misura-pop__velo" data-chiudi></div>
  <div class="misura-pop__foglio" role="dialog" aria-modal="true" aria-labelledby="mpTitolo">
    <button type="button" class="misura-pop__x" data-chiudi aria-label="Chiudi">×</button>
    <span class="etichetta" id="mpNum"></span>
    <h3 id="mpTitolo"></h3>
    <p id="mpDove"></p>
    <label class="misura-pop__campo"><input type="number" inputmode="decimal" id="mpValore"><span id="mpUnita"></span></label>
    <p class="misura-pop__errore" id="mpErrore" hidden></p>
    <div class="misura-pop__tasti">
      <button type="button" class="bottone" id="mpSalva">Salva</button>
      <button type="button" class="link-riga" id="mpProssima">Salva e vai alla prossima</button>
    </div>
  </div>`;
document.querySelector('.bulier-account').appendChild(pop);
const mp = id => pop.querySelector('#' + id);
let mpK = null;
function ordineDi(k){ return ordineCorpo; }
function apriMisura(k){
  if(!M[k] || M[k].scelta) return;
  mpK = k; scegli(k);
  const ord = ordineDi(k), n = ord.indexOf(k);
  mp('mpNum').textContent = n >= 0 ? `Misura ${n+1} di ${ord.length}` : 'Misura';
  mp('mpTitolo').textContent = M[k].n;
  mp('mpDove').textContent = M[k].dove;
  const inp = mp('mpValore');
  inp.min = M[k].min; inp.max = M[k].max;
  inp.value = inserite.has(k) ? M[k].v : '';
  inp.placeholder = `es. ${M[k].v}`;
  mp('mpUnita').textContent = M[k].u || '';
  mp('mpErrore').hidden = true;
  mp('mpProssima').hidden = n < 0 || n === ord.length - 1;
  pop.hidden = false;
  document.documentElement.classList.add('pop-aperto');
  setTimeout(() => inp.focus(), 60);
}
function chiudiMisura(){ pop.hidden = true; mpK = null; document.documentElement.classList.remove('pop-aperto'); }
function salvaMisura(){
  const k = mpK, inp = mp('mpValore'), v = parseFloat(String(inp.value).replace(',', '.'));
  const err = mp('mpErrore');
  if(isNaN(v)){ err.textContent = `Scrivi la misura in ${M[k].u}.`; err.hidden = false; return false; }
  if(v < M[k].min || v > M[k].max){ err.textContent = `Di solito è fra ${M[k].min} e ${M[k].max} ${M[k].u}: ricontrolla col metro.`; err.hidden = false; return false; }
  M[k].v = v;
  const campo = document.querySelector(`.riga[data-k="${k}"] input`);
  if(campo) campo.value = v;
  segnaInserita(k);
  try {
    const dati = {}; Object.keys(M).forEach(x => dati[x] = M[x].v);
    localStorage.setItem(CHIAVE_MISURE, JSON.stringify(dati));
  } catch(e){}
  if(typeof formaScelta !== 'undefined' && ordineCorpo.includes(k)) formaScelta = null;
  disegna(); calcola();
  return true;
}
mp('mpSalva').addEventListener('click', () => { if(salvaMisura()) chiudiMisura(); });
mp('mpProssima').addEventListener('click', () => {
  const k = mpK; if(!salvaMisura()) return;
  const ord = ordineDi(k), dopo = ord.slice(ord.indexOf(k) + 1);
  const prossima = dopo.find(x => !inserite.has(x)) || dopo[0];
  prossima ? apriMisura(prossima) : chiudiMisura();
});
mp('mpValore').addEventListener('keydown', e => { if(e.key === 'Enter'){ e.preventDefault(); mp('mpProssima').hidden ? mp('mpSalva').click() : mp('mpProssima').click(); } });
pop.addEventListener('click', e => { if(e.target.closest('[data-chiudi]')) chiudiMisura(); });
document.addEventListener('keydown', e => { if(e.key === 'Escape' && !pop.hidden) chiudiMisura(); });

/* tocca un numero sul manichino = si apre la sua finestra */
svg.addEventListener('click', e => {
  const k = e.target.dataset && e.target.dataset.k; if(!k) return;
  apriMisura(k);
});



/* ---------- forma e taglia ----------
   Cinque forme gia' pronte, con i nomi che usano tutte. Sceglierne una
   mette misure di partenza (sulla taglia che porti di solito) e l'omino
   prende quella forma. Poi, se inserisci le misure vere, la forma si
   ricalcola da sola. */
const FORME = {
  pera:       {n:'Pera', t:'I fianchi sono più ampi del seno. Valorizzano la parte alta scolli e spalle strutturate; sotto, pantaloni palazzo e jeans a zampa che scendono dritti dal fianco.',
               d:{seno:-4, vita:-18, fianchi:8, spalle:-1}},
  clessidra:  {n:'Clessidra', t:'Seno e fianchi quasi uguali e vita ben segnata. Ti stanno bene i capi che segnano la vita: cinture, abiti a portafoglio, pantaloni a vita alta.',
               d:{seno:0, vita:-22, fianchi:2, spalle:0}},
  dritta:     {n:'Dritta', t:'Seno, vita e fianchi simili. Danno forma i capi che creano punto vita: giacche avvitate, cinture, pantaloni con le pinces.',
               d:{seno:0, vita:-10, fianchi:1, spalle:0}},
  mela:       {n:'Mela', t:'Il volume sta al centro. Ti stanno bene i tessuti che scendono morbidi, le linee lunghe e verticali e i cardigan aperti.',
               d:{seno:2, vita:-2, fianchi:0, spalle:0}},
  rovesciato: {n:'Triangolo rovesciato', corto:'Triangolo inv.', t:'Spalle e seno più ampi dei fianchi. Equilibrano gonne e pantaloni con un po\' di volume, e scolli a V sopra.',
               d:{seno:4, vita:-14, fianchi:-6, spalle:3}}
};
let formaScelta = null;   /* la forma scelta a mano, finche' non si tocca una misura */

/* la sagomina del bottone: spalle, vita, fianchi in proporzione */
function sagomina(k){
  const d = FORME[k].d, sh = 9 + d.spalle*.6 + d.seno*.25, wa = 6.2 + (d.vita+10)*.18, hi = 8.6 + d.fianchi*.32;
  const c = 15, p = [[c+3,4],[c+sh,10],[c+sh*.92,18],[c+wa,27],[c+hi,37],[c+hi*.62,51],[c-hi*.62,51],[c-hi,37],[c-wa,27],[c-sh*.92,18],[c-sh,10],[c-3,4]];
  return `<svg viewBox="0 0 30 54" aria-hidden="true"><circle cx="15" cy="3.2" r="0" /><path d="${curva(p.map(q=>[q[0],q[1]+1]))}"/></svg>`;
}
document.getElementById('formeTutte').innerHTML = Object.keys(FORME).map(k =>
  `<button type="button" data-forma="${k}">${sagomina(k)}<span>${FORME[k].corto || FORME[k].n}</span></button>`).join('');
document.getElementById('formeTutte').addEventListener('click', e => {
  const b = e.target.closest('button'); if(!b) return;
  const k = b.dataset.forma, d = FORME[k].d;
  const i = Math.max(0, ['38','40','42','44','46','48'].indexOf(String(M.solita.v)));
  const base = 82 + 4*i;                       /* seno di partenza per la taglia */
  const val = {seno: base + d.seno, vita: base + d.vita, fianchi: base + 8 + d.fianchi, spalle: 37 + i*.5 + d.spalle,
               sottoseno: base - 14 + d.seno*.4};
  Object.entries(val).forEach(([m, v]) => {
    M[m].v = Math.round(v);
    const campo = document.querySelector(`.riga[data-k="${m}"] input`); if(campo) campo.value = M[m].v;
  });
  formaScelta = k;
  disegna(); calcola();
});
/* appena la cliente scrive una misura vera, la forma torna calcolata */
document.getElementById('righeCorpo').addEventListener('input', () => { formaScelta = null; calcola(); });

function calcola(){
  const se = num('seno'), vi = num('vita'), fi = num('fianchi');
  let f = null;
  if(se && vi && fi){
    if(vi >= se*.92 && vi >= fi*.85) f = 'mela';
    else if(Math.abs(se-fi) <= 5 && vi <= Math.min(se,fi)*.77) f = 'clessidra';
    else if(fi - se > 5) f = 'pera';
    else if(se - fi > 5) f = 'rovesciato';
    else f = 'dritta';
  }
  if(formaScelta) f = formaScelta;
  document.getElementById('formaNome').textContent = f ? FORME[f].n : 'Inserisci seno, vita e fianchi';
  /* il consiglio sui capi sotto la forma e' tolto (Andrea, 04/10/2026): tornera'
     come "prodotti consigliati per il tuo fisico", con i metafield */
  document.querySelectorAll('#formeTutte button').forEach(b => b.classList.toggle('si', b.dataset.forma === f));
  const avviso = document.getElementById('formaAvviso');
  avviso.hidden = !formaScelta;
  avviso.textContent = formaScelta ? `Misure di partenza per la forma ${FORME[f].n} in taglia ${M.solita.v}. Correggile col metro per un consiglio più preciso.` : '';

  /* la taglia consigliata non si mostra piu' (Andrea, 04/10/2026) */
}

/* ============================================================
   LE FOTO DELLA CLIENTE (04/10/2026, Andrea)
   Servono a BULIER per vedere com'e' fatta la cliente: NON calcolano
   misure (le misure si scrivono a mano). Si caricano solo dopo
   l'accesso e col consenso. Vanno a SEMPLIFY dal proxy dell'app
   (ACCOUNT.foto = /apps/semplify/foto), in tre passi:
   1. {azione:'carica', quale, tipo, consenso} -> {ok, url, percorso}
      url = indirizzo firmato per mettere il file nello spazio privato
   2. PUT del file su url
   3. {azione:'conferma', quale, percorso} -> {ok}
   Poi {azione:'elenco'} -> {ok, consenso, foto:{davanti:{anteprima}, ...}}
   e {azione:'cancella', quale} -> {ok}.
   Prima di partire la foto si rimpicciolisce (1280px, max ~600 KB) e si
   ricodifica in JPEG: pesa meno e perde i dati nascosti (per esempio il GPS).
   Prima, fino al 04/10, le foto restavano nel browser e MediaPipe ne
   ricavava le misure: tolto su richiesta di Andrea.
   ============================================================ */
const consenso = document.getElementById('fotoConsenso');
const esitoFoto = document.getElementById('fotoEsito');
const scatti = [...document.querySelectorAll('.scatto')];

async function chiediFoto(corpo){
  const r = await fetch(ACCOUNT.foto, { method: 'POST', headers: { 'Content-Type': 'text/plain' }, body: JSON.stringify(corpo), credentials: 'same-origin' });
  const j = await r.json().catch(() => ({}));
  if(!r.ok || j.ok !== true) throw new Error(j.errore || 'servizio');
  return j;
}
function dilloFoto(testo, errore){
  if(!esitoFoto) return;
  esitoFoto.hidden = false; esitoFoto.textContent = testo;
  esitoFoto.classList.toggle('ricava-esito--errore', !!errore);
}
/* La foto si rimpicciolisce PRIMA di partire: lato lungo 1280px, JPEG.
   Se pesa ancora più di 600 KB si abbassa la qualità (0.8 → 0.7 → 0.6).
   Ricodificare in JPEG toglie anche i dati nascosti (per esempio il GPS).
   Una foto da 8-12 MB del telefono diventa di solito 200-400 KB. */
const LATO_MAX = 1280, PESO_MAX = 600 * 1024;
async function rimpicciolisci(file){
  const url = URL.createObjectURL(file);
  try{
    const img = new Image();
    await new Promise((ok, no) => { img.onload = ok; img.onerror = no; img.src = url; });
    const k = Math.min(1, LATO_MAX / Math.max(img.naturalWidth, img.naturalHeight));
    const c = document.createElement('canvas');
    c.width = Math.round(img.naturalWidth * k); c.height = Math.round(img.naturalHeight * k);
    c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
    let blob = null;
    for(const q of [.8, .7, .6]){
      blob = await new Promise(ok => c.toBlob(ok, 'image/jpeg', q));
      if(blob && blob.size <= PESO_MAX) break;
    }
    if(!blob) throw new Error('foto');
    return blob;
  } finally { URL.revokeObjectURL(url); }
}
function mostraFoto(l, src){
  l.style.backgroundImage = src ? `url("${src}")` : '';
  l.classList.toggle('ha-foto', !!src);
  l.querySelector('.scatto__togli').hidden = !src;
}
function abilitaFoto(){
  const si = !!(ACCOUNT.cliente && ACCOUNT.foto && consenso && consenso.checked);
  scatti.forEach(l => { l.classList.toggle('scatto--spento', !si); l.querySelector('input').disabled = !si; });
}
if(consenso) consenso.addEventListener('change', abilitaFoto);
abilitaFoto();

scatti.forEach(l => {
  const inp = l.querySelector('input'), quale = l.dataset.scatto;
  inp.addEventListener('change', async () => {
    const f = inp.files[0]; inp.value = ''; if(!f) return;
    l.classList.add('scatto--carica'); dilloFoto('Invio la foto…');
    try{
      const blob = await rimpicciolisci(f);
      const pass = await chiediFoto({ azione: 'carica', quale, tipo: 'image/jpeg', consenso: true });
      const put = await fetch(pass.url, { method: 'PUT', headers: { 'Content-Type': 'image/jpeg' }, body: blob });
      if(!put.ok) throw new Error('caricamento');
      await chiediFoto({ azione: 'conferma', quale, percorso: pass.percorso });
      mostraFoto(l, URL.createObjectURL(blob));
      dilloFoto('Foto inviata a BULIER ✓');
    } catch(e){
      console.error(e);
      dilloFoto('Non siamo riusciti a inviare la foto. Riprova più tardi.', true);
    } finally { l.classList.remove('scatto--carica'); }
  });
  l.querySelector('.scatto__togli').addEventListener('click', async e => {
    e.preventDefault(); e.stopPropagation();
    try{ await chiediFoto({ azione: 'cancella', quale }); mostraFoto(l, null); dilloFoto('Foto cancellata ✓'); }
    catch(err){ dilloFoto('Non siamo riusciti a cancellare la foto. Riprova più tardi.', true); }
  });
});

/* le foto gia' inviate: si mostrano le anteprime che da' SEMPLIFY */
if(ACCOUNT.cliente && ACCOUNT.foto){
  chiediFoto({ azione: 'elenco' }).then(j => {
    if(j.consenso && consenso){ consenso.checked = true; abilitaFoto(); }
    scatti.forEach(l => { const x = j.foto && j.foto[l.dataset.scatto]; if(x && x.anteprima) mostraFoto(l, x.anteprima); });
  }).catch(() => {});
}

document.getElementById('salva').addEventListener('click', async e => {
  const bottone = e.currentTarget;
  const dati = {};
  Object.keys(M).forEach(k => dati[k] = M[k].v);
  try { localStorage.setItem(CHIAVE_MISURE, JSON.stringify(dati)); } catch(err){}
  let testo = 'Misure salvate su questo telefono ✓';
  if(ACCOUNT.cliente){
    bottone.disabled = true; bottone.textContent = 'Salvo nel tuo account…';
    const nome = document.getElementById('formaNome').textContent;
    const forma = Object.keys(FORME).find(k => FORME[k].n === nome);
    const ok = await mandaAllAccount({ misure: { ...dati, forma } });
    bottone.disabled = false;
    testo = ok ? 'Salvate nel tuo account ✓' : 'Salvate solo su questo telefono: riprova più tardi';
  }
  bottone.textContent = testo;
  setTimeout(() => bottone.textContent = 'Salva le mie misure', 2600);
});

/* "Cancella foto e misure": toglie tutto quello che sta nel browser */
const cancella = document.getElementById('cancellaTutto');
if(cancella) cancella.addEventListener('click', e => {
  e.preventDefault();
  try { localStorage.removeItem(CHIAVE_MISURE); } catch(err){}
  if(ACCOUNT.cliente) mandaAllAccount({ azione: 'cancella' }).finally(() => location.reload());
  else location.reload();
});

scegli('seno'); calcola();
